import React, { useState } from "react";
import { View, StyleSheet, Image, Text as MyText } from "react-native";

//Custom Imports
import color from "@constants/color";
import { scale } from "@utils/scale";
import t from "@constants/localization";
import Text from "@components/CustomText";
import { fontFamily } from "@utils/styles";
import CLAppLogo from "@assets/svg/Jrny/CLAppLogo";
import LockProgressIcon from "@assets/svg/Contest/LockProgressIcon";
import StarProgressIcon from "@assets/svg/Contest/StarProgressIcon";
import ContestProgressOne from "@assets/svg/Contest/ContestProgressOne";
import TrophyProgressIcon from "@assets/svg/Contest/TrophyProgressIcon";

const PATH = "screens/Contest/contestDetails";

const AllProgresIcons = {
  profileIcon: CLAppLogo,
  startProgressIcon: ContestProgressOne,
  trophyProgressIcon: TrophyProgressIcon,
  lockProgressIcon: LockProgressIcon,
  finalProgressIcon: StarProgressIcon,
};

const ContestProgressItem = ({
  index = 0,
  array = [],
  item = {},
  current_slab_index = 0,
  tl_image = "",
  tl_name = "",
  contest_ended = false,
  language = "",
}) => {
  const { icon = "", left_side_data = [], right_side_data = [] } = item || {};
  const checkLastIndex = contest_ended && index === current_slab_index + 1;
  const currentUserPosition = index === current_slab_index + 1;

  const ProgressIcon = AllProgresIcons[icon];
  const outerIndex = index;

  const renderRightItem = (item, index) => {
    const {
      count = 0,
      horizontal = false,
      isNameBold = false,
      name = "",
    } = item;
    const item_color =
      checkLastIndex || currentUserPosition
        ? color.color_3782A3
        : icon === "startProgressIcon"
          ? color.lightBlack
          : icon === "finalProgressIcon"
            ? "#FFE38A"
            : color.mediumBlack;
    const nameColor =
      checkLastIndex || currentUserPosition
        ? color.color_3782A3
        : color.lightBlack;
    return (
      <View style={styles.rightViewContainer} key={`${name}${index}`}>
        {name ? (
          <Text
            variant={
              icon === "startProgressIcon" ? "title_18_semi" : "caption_2"
            }
            newfont={true}
            numberOfLines={2}
            style={[
              styles.nameText,
              {
                color: nameColor,
                marginTop:
                  icon === "startProgressIcon"
                    ? scale(10)
                    : (currentUserPosition && count === null) ||
                        count === undefined
                      ? scale(5)
                      : 0,
                fontFamily:
                  icon === "profileIcon" ? fontFamily.bold : fontFamily.regular,
                lineHeight: currentUserPosition ? 18 : 24,
              },
            ]}
          >
            {name}
          </Text>
        ) : null}
        {count !== null && icon !== "startProgressIcon" ? (
          <Text
            variant={icon === "finalProgressIcon" ? "heading_24" : "title_18"}
            newfont={true}
            numberOfLines={1}
            style={[
              styles.countText,
              {
                color: item_color,
                lineHeight: icon === "finalProgressIcon" ? 28 : 24,
                alignSelf: "flex-start",
                marginTop:
                  icon === "finalProgressIcon"
                    ? scale(10)
                    : !name
                      ? scale(5)
                      : 0,
              },
            ]}
          >
            {`₹${count}`}
          </Text>
        ) : null}
      </View>
    );
  };

  const renderLeftItem = (left_item, index) => {
    const {
      count = 0,
      horizontal = false,
      isNameBold = false,
      name = "",
    } = left_item;
    const item_color =
      checkLastIndex || currentUserPosition
        ? color.color_3782A3
        : color.mediumBlack;
    const nameColor =
      checkLastIndex || currentUserPosition
        ? color.color_3782A3
        : color.lightBlack;
    return (
      <View
        style={[
          styles.leftViewContainer,
          {
            marginTop:
              icon === "finalProgressIcon" ||
              (language !== "en" && currentUserPosition)
                ? scale(4)
                : 0,
          },
        ]}
        key={`${name}${index}`}
      >
        {count !== null && !checkLastIndex ? (
          <Text
            variant="title_18"
            newfont={true}
            numberOfLines={1}
            style={[
              styles.countText,
              {
                alignSelf: "flex-end",
                color: item_color,
              },
            ]}
          >
            {count}
          </Text>
        ) : null}
        {name ? (
          <MyText
            numberOfLines={3}
            style={[
              styles.nameStyle,
              {
                color: nameColor,
                fontFamily: checkLastIndex
                  ? fontFamily.semiBold
                  : fontFamily.bold,
                marginStart: count !== null && checkLastIndex ? 0 : 4,
                fontSize: checkLastIndex ? 14 : 16,
                textAlign: "right",
                lineHeight: checkLastIndex ? 20 : 24,
                marginRight: checkLastIndex ? 4 : 0,
              },
              checkLastIndex
                ? { maxWidth: language === "en" ? scale(120) : scale(110) }
                : {},
            ]}
          >
            {name}
          </MyText>
        ) : null}
        {count !== null && checkLastIndex ? (
          <MyText
            numberOfLines={3}
            style={[
              styles.rightCountStyle,
              {
                color: item_color,
              },
            ]}
          >
            {count}
          </MyText>
        ) : null}
      </View>
    );
  };

  return (
    <View key={`${tl_name}${index}`} style={styles.container}>
      <View style={styles.leftSideContainer}>
        {left_side_data.length !== 0
          ? left_side_data.map(renderLeftItem)
          : null}
        {!contest_ended && currentUserPosition && array[index + 1] ? (
          <Text
            variant={"caption_2"}
            newfont={true}
            numberOfLines={1}
            style={styles.moreRequiredText}
          >
            {`${Math.abs(
              array[index + 1].left_side_data[0]?.count -
                left_side_data[0]?.count,
            )} ${t(`${PATH}/moreRequired`)}`}
          </Text>
        ) : null}
      </View>
      <View style={styles.middleContainer}>
        <View style={styles.centralAlignment}>
          {icon === "profileIcon" ? (
            tl_image &&
            tl_image !==
              "https://storage.googleapis.com/cm-catalogue-images/1589963078748leader_image.png" ? (
              <View style={styles.logoContainer}>
                <Image
                  resizeMode={"cover"}
                  style={styles.profileIcon}
                  source={{ uri: tl_image }}
                />
              </View>
            ) : (
              <View style={styles.logoContainer}>
                <CLAppLogo height={32} width={32} />
              </View>
            )
          ) : (
            <ProgressIcon
              innerColor={
                current_slab_index + 2 > index || checkLastIndex
                  ? color.white
                  : color.color_808080
              }
              color={
                current_slab_index + 2 > index || checkLastIndex
                  ? color.darkSkyBlue
                  : color.color_D9D9D9
              }
            />
          )}
        </View>
        {index !== array.length - 1 && (
          <View style={styles.verticaleLineContainer} />
        )}
      </View>
      <View style={styles.rightSideContainer}>
        {right_side_data.length !== 0
          ? right_side_data.map(renderRightItem)
          : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flex: 1,
  },
  leftSideContainer: {
    flex: 0.47,
    alignItems: "flex-end",
  },
  middleContainer: {
    flex: 0.15,
    alignItems: "center",
  },
  rightSideContainer: {
    flex: 0.38,
    justifyContent: "flex-start",
  },
  rightViewContainer: {
    justifyContent: "center",
  },
  centralAlignment: {
    justifyContent: "center",
    alignItems: "center",
  },
  verticaleLineContainer: {
    height: 35,
    backgroundColor: "transparent",
  },
  titleText: {
    color: color.mediumBlack,
  },
  nameText: {
    color: color.mediumBlack,
  },
  countText: {
    color: color.mediumBlack,
  },
  rightCountStyle: {
    fontFamily: fontFamily.bold,
    fontSize: 20,
  },
  profileIcon: {
    width: 32,
    height: 32,
    borderRadius: 16,
  },
  leftViewContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  logoContainer: {
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    backgroundColor: color.modalBg,
  },
  contestEndedText: {
    position: "absolute",
    marginStart: 0,
    fontFamily: fontFamily.bold,
    end: 0,
    bottom: 20,
    zIndex: 100,
  },
  moreRequiredText: {
    fontFamily: fontFamily.bold,
    color: color.color_3782A3,
  },
  nameStyle: {
    fontFamily: fontFamily.bold,
    color: color.color_3782A3,
  },
});

export default React.memo(ContestProgressItem);
